export interface ParsedStatisticsXml {
	Statistics: {
		children?: StatsConfig
	};
}
export interface StatsConfig {
	events?: StatsEvent[];
	pages?: StatsPage[];
	servers?: ServersConfig[];
}

export interface StatsEvent {
	children?: {
		Event?: {
			attrs: {
				name: string;
			};
		}[];
	};
}

export interface StatsPage {
	children?: {
		Page?: {
			attrs: {
				name: string;
			};
		}[];
	};
}

export interface ServersConfig {
	children?: {
		GoogleAnalytics?: AnalyticsConfigNode[];
		Piwik?: PiwikConfigNode[];
		WebTrends?: WebTrendsConfigNode[];
		Xiti?: XitiConfigNode[];
	};
}

export interface AnalyticsConfigNode {
	attrs: AnalyticsConfig;
}

export interface AnalyticsConfig {
	account?: string;
	name?: string;
	label?: string;
	session?: string;
	dimension1?: string;
	dimension2?: string;
	dimension3?: string;
	dimension4?: string;
	dimension5?: string;
	dimension6?: string;
	dimension7?: string;
	dimension8?: string;
	dimension9?: string;
}

export interface PiwikConfigNode {
	attrs: PiwikConfig;
}

export interface PiwikConfig {
	id?: string;
	url?: string;
}

export interface WebTrendsConfigNode {
	attrs: WebTrendsConfig;
}

export interface WebTrendsConfig {
	id?: string;
	url?: string;
}

export interface XitiConfigNode {
	attrs: XitiConfig;
}

export interface XitiConfig {
	url?: string;
}

export interface Tracker {
	trackPage: (page: string, url: string, title: string) => void;
	trackEvent: (category: string, action: string, label: string, value?: number) => void;
	isLoaded: () => boolean;
}

// intern
export interface ResourceCredentials {
	login: string;
	password: string;
}

export enum TrackingType {
	Page = 'Page',
	Event = 'Event',
}

export interface TrackingPage {
	type: TrackingType.Page;
	arguments: {
		page: string;
		url: string;
		title: string;
	};
}

export interface TrackingEvent {
	type: TrackingType.Event;
	arguments: {
		category: string;
		action: string;
		label: string;
		value?: number;
	};
}

export type Tracking = TrackingPage | TrackingEvent;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/statistics/typings.ts